/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import NoteAddOutlined from "@mui/icons-material/AutoFixHighOutlined";
import {Wizard} from "react-use-wizard";
import {useSelectWizardOpenc, useSliceActions} from "../../../redux/ducks/Wizard/SliceProvider";
import {IconButton, Slide, Toolbar, Typography} from '@mui/material';
import {TransitionProps} from "@mui/material/transitions";
import {StyledArgosDialog} from "../Dialogs/ArgosDialog";
import ArgosDialogHeader from '../Dialogs/ArgosDialogHeader';
import CloseIcon from '@mui/icons-material/Close';
import ArgosFlexbox from '../Containers/ArgosFlexbox';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
  headerTitle: string
  children?: React.ReactNode
  fullScreen?: boolean
  height?: string
  width?: string
}

export const WizardDialog = (props: IProps) => {
  const isWizardOpen: boolean = useSelectWizardOpenc()
  const {setWizardOpen, clearState} = useSliceActions()
  const dispatch = useDispatch()
  const handleCloseDialog = () => {
    dispatch(setWizardOpen(false))
    dispatch(clearState())
  }
  return (
    <StyledArgosDialog
      fullScreen={props?.fullScreen ?? true}
      open={isWizardOpen}
      onClose={() => null}
      TransitionComponent={Transition}
      transitionDuration={0}
      height={props?.height ?? '70vh'}
      width={props?.width ?? '65vw'}
      // style={{height: '100%'}}
    >
      <div style={{display: 'flex', flexFlow: 'column nowrap', height: '100%'}}>
        <div style={{flex: '0 0 auto'}}>
          <ArgosDialogHeader>
              <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
                <Typography sx={{color: 'white', ml: 2, flex: 1}} variant="h6" component="div">
                  {props?.headerTitle}
                </Typography>
                <IconButton onClick={() => handleCloseDialog()} sx={{color: 'white', padding: 0, fontSize: 'small'}}> 
                    <CloseIcon />
                </IconButton>
              </ArgosFlexbox>
          </ArgosDialogHeader>
        </div>
        <div style={{flex: '1 1 80%', overflow: 'hidden',padding: '20px 20px 40px 0px'}}>
          <Wizard>
            {props?.children}
          </Wizard>
        </div>
      </div>
    </StyledArgosDialog>
  )
}